import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, IconButton, Box, Tooltip } from '@mui/material';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const More = ({ id, status, setCurID, setIsSuccessModal, permissions, setIsOnApproveModal, setIsRejectModal, setIsApproveModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
    setCurID(id);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const MenuItemWithTooltip = (title, MenuItem) => title ? <Tooltip title={title} arrow placement="right"><Box component="span">{MenuItem}</Box></Tooltip> : MenuItem;

  return (
    <>
      <Box>
        <IconButton onClick={handleClick}>
          <MoreIcon data-testid="MoreIcon"/>
        </IconButton>

        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
        >
          {MenuItemWithTooltip(!permissions.update && (status === 'Создана' || status === 'Активна') ? DISABLED_CONTROL_TOOLTIP : null,
            <MenuItem
              component={RouterLink}
              to={getRouteWithParam(ROUTES.BONUSES_ADD_EVENT, ':id', id)}
              onClick={(e) => handleClose(e)}
              disabled={!permissions.update}
              data-testid="EditBonus"
              sx={{ display: status === 'Архив' || status === 'archive' ? 'none' : undefined }}
            >
              Редактировать
            </MenuItem>
          )}

          {MenuItemWithTooltip(!permissions['copy'] ? DISABLED_CONTROL_TOOLTIP : null,
            <MenuItem
              component={RouterLink}
              to={getRouteWithParam(ROUTES.BONUSES_COPY_EVENT, ':id', id)}
              onClick={(e) => handleClose(e)}
              data-testid="CopyBonus"
              disabled={!permissions['copy']}
            >
              Копировать
            </MenuItem>
          )}

          <MenuItem
            onClick={(e) => {handleClose(e); setIsOnApproveModal();}}
            sx={{
              color: 'success.main',
              display: !(status === 'Создана' || status === 'Доработка') ? 'none' : undefined
            }}
            data-testid="OnApprove"
          >
            Отправить на одобрение
          </MenuItem>

          <MenuItem
            onClick={(e) => {handleClose(e); setIsApproveModal();}}
            sx={{
              color: 'success.main',
              display: !(status === 'На одобрении' && permissions.approve) ? 'none' : undefined
            }}
            data-testid="Approve"
          >
            Одобрить кампанию
          </MenuItem>

          <MenuItem
            onClick={(e) => {handleClose(e); setIsRejectModal();}}
            sx={{
              color: 'error.main',
              display: !(status === 'На одобрении' && permissions.approve) ? 'none' : undefined
            }}
            data-testid="Reject"
          >
            Отклонить кампанию
          </MenuItem>

          {MenuItemWithTooltip(!permissions.archive && !(status === 'Архив' || status === 'archive') ? DISABLED_CONTROL_TOOLTIP : null,
            <MenuItem
              onClick={(e) => {handleClose(e); setIsSuccessModal();}}
              sx={{
                color: 'error.main',
                display: status === 'Архив' || status === 'archive' ? 'none' : undefined
              }}
              disabled={!permissions.archive}
              data-testid="ArchiveBonus"
            >
              В архив
            </MenuItem>
          )}
        </Menu>
      </Box>
    </>
  );
};

More.propTypes = {
  id: PropTypes.any,
  status: PropTypes.string,
  setCurID: PropTypes.func,
  setIsSuccessModal: PropTypes.func,
  setIsOnApproveModal: PropTypes.func,
  setIsApproveModal: PropTypes.func,
  setIsRejectModal: PropTypes.func,
  permissions: PropTypes.object
};
